import { render, staticRenderFns } from "./post_quote.vue?vue&type=template&id=0d85e0ae&scoped=true&"
import script from "./post_quote.vue?vue&type=script&lang=js&"
export * from "./post_quote.vue?vue&type=script&lang=js&"
import style0 from "./post_quote.vue?vue&type=style&index=0&id=0d85e0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d85e0ae",
  null
  
)

export default component.exports